import type { GeojsonFieldsType } from '../../types';

interface Polygon {
    id: string;
    name: string;
    color: string;
    geojson: Geojson;
    isEditable: boolean;
    isRemovable: boolean;
    isSelectable: boolean;
    isSelected: boolean;
    isHidden: boolean;
    points: number[][];
}

type GeojsonType = 'Polygon' | 'MultiPolygon';

interface Geojson {
    type: GeojsonType;
    coordinates: number[][][];
}

class SelectedArea {
    static geojson: Geojson = { type: 'MultiPolygon', coordinates: [] };
    static listeners: { edit: Function[] } = { edit: [] };
    static polygons: Polygon[] = [];
    static targeoMap: any = null;
    static drawStyle = [
        { strokeWeight: '6px', strokeColor: '#ffffff', strokeOpacity: '0.8', fill: '#ffffff77' },
        { strokeWeight: '3px', strokeColor: '#5e9dd3', strokeOpacity: '1' },
    ];
    static whenUserClickOutsidePolygon: Function = () => {};

    static resetGeometry() {
        console.warn('SelectedArea, resetGeometry');
        SelectedArea._clearArea();
    }

    private static _clearArea() {
        for (let i = 0, ii = SelectedArea.polygons.length; i < ii; i++) {
            console.debug(
                'SelectedArea.setGeometry, removing from map old polygons',
                SelectedArea.polygons[i].id
            );
            if (SelectedArea.targeoMap) {
                SelectedArea.targeoMap.UORemove(SelectedArea.polygons[i].id);
            } else {
                console.error('SelectedArea.setGeometry, SelectedArea.targeoMap is not defined');
            }
        }
        SelectedArea.polygons = [];
    }

    static setGeometry(geojson) {
        try {
            SelectedArea._clearArea();

            if (!geojson || !geojson?.coordinates || !geojson?.type) {
                console.warn('SelectedArea.setGeometry, invalid geojson:', geojson);
                return;
            }

            geojson = JSON.parse(JSON.stringify(geojson));
            if (geojson.type === 'Polygon') {
                console.debug('SelectedArea.setGeometry, converting Polygon to MultiPolygon');
                geojson.type = 'MultiPolygon';
                geojson.coordinates = [geojson.coordinates];
            }

            SelectedArea.geojson = JSON.parse(JSON.stringify(geojson));

            for (let i = 0, ii = geojson.coordinates.length; i < ii; i++) {
                // @ts-ignore
                SelectedArea.polygons.push(
                    new Targeo.MapObject.Polyline(geojson.coordinates[i], {
                        drawStyle: SelectedArea.drawStyle,
                        closed: true,
                        interactive: false,
                    })
                );
            }

            SelectedArea._drawArea();
        } catch (e) {
            alert('Nie udało się przetworzyć danych dotyczących obszaru');
            SelectedArea.geojson = { type: 'MultiPolygon', coordinates: [] };
            console.error(
                'SelectedArea: Nie udało się przetworzyć danych dotyczących obszaru: ' +
                    e?.message +
                    ', ',
                SelectedArea?.geojson
            );
        }
    }

    static setMap(targeoMap: any) {
        SelectedArea.targeoMap = targeoMap;
    }

    static getGeometry(): GeojsonFieldsType {
        return SelectedArea.geojson;
    }

    // static remove() {
    //     console.log('SelectedArea.remove');
    //     SelectedArea.resetGeometry();
    //     // for (let i = 0, ii = SelectedArea.polygons.length; i < ii; i++) {
    //     //     SelectedArea.targeoMap.UORemove(SelectedArea.polygons[i].id);
    //     // }
    //     // SelectedArea.polygons = [];
    // }

    static edit(targeoMap: any, callbacks) {
        SelectedArea.targeoMap = targeoMap;
        SelectedArea.listeners = { edit: [] };

        SelectedArea.listeners.edit = [
            SelectedArea.targeoMap.modules.PolygonEditor.listen('onModifyEnd', () => {
                console.log('onModifyEnd, add some action here, to save changes or accept button');
                if (typeof callbacks.onChange == 'function') {
                    callbacks.onChange();
                }
            }),
            SelectedArea.targeoMap.modules.PolygonEditor.listen('onDrawEnd', evt => {
                console.log('onDrawEnd, add some action here, to save changes or accept button');
                SelectedArea.polygons.push(evt.object);
                if (typeof callbacks.onChange == 'function') {
                    callbacks.onChange();
                }
            }),
            SelectedArea.targeoMap.modules.PolygonEditor.listen('onRemove', evt => {
                console.log('onRemove, add some action here, to save changes or accept button');
                let pidx = SelectedArea.polygons.indexOf(evt.object);
                if (pidx >= 0) {
                    SelectedArea.targeoMap.UORemove(evt.object.id);
                    SelectedArea.polygons.splice(pidx, 1);
                }
                if (typeof callbacks.onChange == 'function') {
                    callbacks.onChange();
                }
            }),
        ];

        var polygons = {};
        for (let i = 0, ii = SelectedArea.polygons.length; i < ii; i++) {
            polygons[SelectedArea.polygons[i].id] = true;
        }
        SelectedArea.targeoMap.modules.PolygonEditor.start({
            objects: polygons,
            draw: 'polygon',
            remove: true,
            drawStyle: SelectedArea.drawStyle,
            snap: false,
        });
    }

    static save() {
        SelectedArea._removeListeners();
        var objects = SelectedArea.targeoMap.modules.PolygonEditor.save();
        let i, ii;
        for (i = 0, ii = objects.length; i < ii; i++) {
            if (this.polygons.indexOf(objects[i]) < 0) {
                this.polygons.push(objects[i]);
            }
        }
        if (!SelectedArea.geojson) {
            SelectedArea.geojson = { type: 'MultiPolygon', coordinates: [] };
        }
        SelectedArea.geojson.coordinates = [];
        for (i = 0, ii = this.polygons.length; i < ii; i++) {
            SelectedArea.geojson.coordinates.push(this.polygons[i].points);
        }
        return SelectedArea.geojson;
    }

    static cancel() {
        SelectedArea._removeListeners();
        SelectedArea.targeoMap.modules.PolygonEditor.cancel();
        let geojson = SelectedArea.geojson;
        // SelectedArea.resetGeometry();
        SelectedArea.setGeometry(geojson);
        // SelectedArea.drawArea();
    }

    private static _removeListeners() {
        SelectedArea.listeners.edit.forEach(function (l) {
            SelectedArea.targeoMap.modules.PolygonEditor.unlistenByKey(l);
        });
        SelectedArea.listeners = { edit: [] };
    }

    private static _drawArea() {
        console.log('SelectedArea, drawArea, polygons:', SelectedArea.polygons.length);
        for (let i = 0, ii = SelectedArea.polygons.length; i < ii; i++) {
            SelectedArea.targeoMap.UOAdd(SelectedArea.polygons[i]);
        }
    }
}

export default SelectedArea;
